module.exports = __webpack_public_path__ + "29b77271d2261345369cf678f3de52eb.svg";